import React, { useEffect } from "react";
import HorizontalLine from "../../../../HorizontalLine";
import LanguageTab from "./LanguageTab";
import navigationEventTracker from "../tracker/navigationEventTracker";

const SideBarOptions = ({tabs}) => {


  const getHorizontalClass = () => {

    const { signOutOptions, nonLoggedInOptions, languageOptions, mobileOptions, profilingOptions } = tabs;
    return (signOutOptions.length + nonLoggedInOptions.length + mobileOptions.length + profilingOptions.length > 0) ? "" :
           (languageOptions ? getDisplayOptions.hiddenOnWeb : getDisplayOptions.hiddenOnAll);
  };


  const renderOptionItems = (optionsArray, onClickHandler) => {
    return optionsArray.map((option, index) => (
        <a className={`navitem ${option.tabClass} ${option.hideOnWeb && getDisplayOptions.hiddenOnWeb}`}  key={index}
          onClick={() => onClickHandler(option.trackingInfo)}
          href={option.url}
          {...(option.id  && { "id": option.id })}
          {...(option.rel && { "rel": option.rel })}
          {...(option.method && { "data-method": option.method })}
          {...(option.toggle && { "data-toggle": option.toggle })}
          {...(option.target && { "data-target": option.target })}
          {...(option.remote && { "data-remote": option.remote ? true : false})}
        >
          <i className={option.iconClass}></i>
          <span>{option.label} </span>
        </a>
    ));
  };

  const LanguageOption = () => (
    <>
      {tabs.languageOptions && <LanguageTab {...tabs.languageOptions} />}
    </>
  );

  const SignOutOption = () => (
    <>
      {tabs.signOutOptions.length > 0 &&
        renderOptionItems(tabs.signOutOptions, navigationEventTracker)}
    </>
  );

  const MobileOption = () => (
    <>
      {tabs.mobileOptions.length > 0 &&
        renderOptionItems(tabs.mobileOptions, navigationEventTracker)}
    </>
  );

  const ProfilingOption = () => (
    <>
      {tabs.profilingOptions.length > 0 &&
        renderOptionItems(tabs.profilingOptions, navigationEventTracker)}
    </>
  );

  const NonLoggedInOption = () => (
    <>
      {tabs.nonLoggedInOptions.length > 0 &&
        renderOptionItems(tabs.nonLoggedInOptions, navigationEventTracker)}
    </>
  );

  const InstallOption = () => (
    <>
      {tabs.installOptions.length > 0 &&
          renderOptionItems(tabs.installOptions, navigationEventTracker)}
    </>
  );

  return (
    <>
      <HorizontalLine
        additionalClasses={`m-t-xs m-b-xs ${getHorizontalClass()}`}
      />

      <LanguageOption />

      <SignOutOption />

      <NonLoggedInOption />

      <ProfilingOption />

      <MobileOption />

      {tabs.installOptions.length > 0 && (
        <HorizontalLine
          additionalClasses={`m-t-xs m-b-xs`}
        />
      )}

      <InstallOption />
    </>
  );
};

export default SideBarOptions;
